module.exports = __webpack_public_path__ + "media/images/landing_section_3-b3f028e6e72727cd1615e10e59904ed8.svg";